import { Link } from "react-router-dom";
import Form from "./Form";
import { CREATE_ABBVIE_ID_CONFIGURED_APP } from "./query";

const CreateIccConfigApp = () => {
    return (
        <div className="custom-shadow p-5">
            <Link to="/global-config/abbvie-id/app-list" className="btn btn-outline-primary mb-5">
                Back
            </Link>
            <h3 className="mb-5">Create AbbVie ID Configured App</h3>

            <Form query={CREATE_ABBVIE_ID_CONFIGURED_APP} />
        </div>
    );
};

export default CreateIccConfigApp;
